import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  alternate?: boolean;
  gray?: boolean;
  secondary?: boolean;
  tertiary?: boolean;
  light?: boolean;
  error?: boolean;
  white?: boolean;
  center?: boolean;
  small?: boolean;
  bold?: boolean;
  fullWidth?: boolean;
  h5?: boolean;
  h4?: boolean;
  h3?: boolean;
  h2?: boolean;
  h1?: boolean;
  hero?: boolean;
  spaced?: boolean;
  noMargin?: boolean;
  block?: boolean;
  noTransform?: boolean;
}

const Text = styled.span`
  ${({ noTransform }: IProps) =>
    !noTransform ? `text-transform: uppercase;` : ``}
  margin-bottom: 1rem;
  color: ${theme.color.primary};
  font-size: ${theme.fontSize.body};
  font-family: ${theme.fontFamily.regular};

  ${({ center }: IProps) => (center ? `text-align:center;` : ``)}
  ${({ bold }: IProps) =>
    bold
      ? `font-family: ${theme.fontFamily.black};`
      : `font-family: ${theme.fontFamily.regular};`}
  ${({ block }: IProps) => (block ? `display: block;` : ``)}
  ${({ fullWidth }: IProps) =>
    fullWidth ? `width:100%; display:block; margin-bottom: 2rem;` : ``}

  ${({ white }: IProps) => (white ? `color: ${theme.color.white};` : "")}

  ${({ spaced }: IProps) =>
    spaced ? `margin: ${theme.global.gutter}rem 0;` : ""}
  ${({ noMargin }: IProps) => (noMargin ? `margin: 0;` : "")}

  ${({ alternate }: IProps) =>
    alternate
      ? `font-family: ${theme.fontFamily.regular}; text-transform: capitalize;`
      : ""}

  ${({ secondary }: IProps) =>
    secondary ? `color: ${theme.color.secondary};` : ""}

  ${({ tertiary }: IProps) =>
    tertiary ? `color: ${theme.color.tertiary};` : ""}

  ${({ gray }: IProps) => (gray ? `color: ${theme.color.gray.medium};` : "")};

  ${({ light }: IProps) => (light ? "font-weight: lighter;" : "")};

  ${({ error }: IProps) => (error ? `color: ${theme.color.red};` : "")};

  ${({ hero }: IProps) =>
    hero ? `font-size: ${theme.fontSize.headings.hero};` : ""};

  ${({ small }: IProps) => (small ? "font-size: 1.2rem;" : "")};

  ${({ h5 }: IProps) =>
    h5 ? `font-size: ${theme.fontSize.headings.h5};` : ""};

  ${({ h4 }: IProps) =>
    h4 ? `font-size: ${theme.fontSize.headings.h4};` : ""};

  ${({ h3 }: IProps) =>
    h3 ? `font-size: ${theme.fontSize.headings.h3};` : ""};

  ${({ h2 }: IProps) =>
    h2 ? `font-size: ${theme.fontSize.headings.h2};` : ""};

  ${({ h1 }: IProps) =>
    h1 ? `font-size: ${theme.fontSize.headings.h1};` : ""};
`;

export default Text;



// WEBPACK FOOTER //
// ./src/components/common/Text/Text.tsx